import { useState, useEffect } from 'react';
import ChatList from './components/ChatList';
import Header from './components/Header';
import './components/chat.css';
import { useSocket } from '../../contexts/SocketContext';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import Toast from '../../components/ToastNotification';
import Profile from './components/Profile';
import { useSelector } from 'react-redux';
import Chat from './components/Chat';
import { decryptUrlSafe } from '../../utils/helpers';
const LOADING_TIMEOUT_MS = 1000;

const ChatPage = () => {
    const { session } = useSelector((state) => state.auth);
    const [selectContact, setSelectContact] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [profileModal, setProfileModal] = useState(false);
    const socket = useSocket();
    const { id } = useParams();
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search)
    const employeeId = decryptUrlSafe(id);

    useEffect(() => {
      const isAuthenticated = params.get('auth') === 'true'
      // if(!location.state?.authenticate) {
      //   navigate('/', { replace: true })
      // }

      if (!isAuthenticated) {
        navigate('/', { replace: true })
      }
    }, []);

    useEffect(() => {
      const timer = setTimeout(() => setIsLoading(false), LOADING_TIMEOUT_MS);
      return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!socket) return;

        socket.on('logout-success', ({ message }) => {
          Toast.success(message);
          navigate('/employee', { replace: true })

          if (id) {
            socket.emit('leave-employee-room', { employeeId: employeeId });
          }
        })

        return () => {
            socket.off('logout-success');
        };
    }, [socket]);
    // {
    //   profileModal && 
    //   <Profile
    //     onClose={() => setProfileModal(false)} 
    //   />
    // }
    return (
      <>
        {isLoading ? (
          <div className="centered-loader">
            <h3 className="loading-dots">Loading Chats<span className="dots"></span></h3>
          </div>
        ) : ( 
        <>
          <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
            <Header title="Contacts" 
              selectedId = {employeeId}
              setProfileModal = {setProfileModal}
            />

            {
              profileModal && session?.is_business ? 
                <Profile
                  onClose={() => setProfileModal(false)} 
                />
              : (<div style={{ display: 'flex', height: '90vh' }}>
                  <div style={{ width: '22%', borderRight: '1px solid #ccc', display: 'flex', height: '90vh' }}>
                      <ChatList 
                        selectedId = {employeeId}
                        contactState = {{
                          selectContact,
                          setSelectContact
                        }}
                      />
                  </div>
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <Chat 
                      selectedId = {employeeId}
                      contactState = {{
                        selectContact,
                        setSelectContact
                      }}
                    />
                  </div>  
                </div>)
              }
          </div>
        </>
        )}
      </>
    );
};

export default ChatPage;
